module.exports = __webpack_public_path__ + "static/media/backWave16.5abe0e07.svg";